import { render, staticRenderFns } from "./TheStakeholderRequest.vue?vue&type=template&id=20b441f6&"
import script from "./TheStakeholderRequest.vue?vue&type=script&lang=js&"
export * from "./TheStakeholderRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports